export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/service-luggage.afbed40d-92b62d.png";